import {Box, Flex, Text} from 'exsportia-components'
import React, {FC} from 'react'
import {useDispatch} from 'react-redux'

import {SessionSelectSession} from '../../api/class-session/types'
import {useLocale} from '../../utils/i18n'
import {Button} from '../../ui/components/button/button'
import {unjoinWaitingListRequest} from '../../services/booking/actions'
import {useModalActions} from '../../utils/modals'
import {useBookingLoader} from '../../services/booking/hooks'
import {WaitingListSessionInfo} from './waiting-list-session-info'

type Props = {
  session: SessionSelectSession
  memberId: string
  waitingBookingId: string
  venueData?: any
  isPast?: boolean
}

export const UnjoinWaitingListModal: FC<Props> = ({
  session,
  memberId,
  waitingBookingId,
  venueData,
  isPast,
}) => {
  const {l} = useLocale()
  const dispatch = useDispatch()
  const {closeModal} = useModalActions()
  const {isLoading} = useBookingLoader()

  const handleUnjoin = () => {
    dispatch(
      unjoinWaitingListRequest({
        waitingBookingId,
        memberId,
        callback: () => {
          closeModal()
        },
        l,
      }),
    )
  }

  return (
    <Box p='16px'>
      <Flex
        flexDirection='column'
        gap='16px'
      >
        <Text
          text={l('unjoinWaitingListDescription' as any) || 'You have a spot on the waiting list. Would you like to cancel this opportunity?'}
          settings={{
            fontSize: '14px',
            color: 'text-secondary',
            textAlign: 'center',
          }}
        />

        <WaitingListSessionInfo
          session={session}
          venueData={venueData}
          variant='waitingListBooked'
          isPast={isPast}
          isLoading={isLoading}
        />

        <Button
          onClick={closeModal}
          type='primary'
          isLoading={isLoading}
        >
           {l('close')}
        </Button>

        <Text
           onClick={handleUnjoin}
           text={l('unjoinWaitingList' as any) || 'Unjoin waiting list'}
           settings={{
             fontSize: '14px',
             color: 'primary',
             cursor: 'pointer',
             fontWeight: 600,
             textAlign: 'center',
           }}
        />
      </Flex>
    </Box>
  )
}
